"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseFormatPercentage = exports.createFormatPercentage = void 0;
const react_1 = require("react");
const context_1 = require("../context/context");
const format_number_1 = require("../format-number/format-number");
const curry_1 = require("../utils/curry");
const ROUND_FUNCTION_MAP = {
    nearest: Math.round,
    up: Math.ceil,
    down: Math.floor,
};
const PERCENTAGE_MULTIPLIER = 100;
function createFormatPercentage(localizeConfigs) {
    return (locale, value, roundingType = null, options) => {
        const percentage = value * PERCENTAGE_MULTIPLIER;
        const percentageValue = roundingType ? ROUND_FUNCTION_MAP[roundingType](percentage) : percentage;
        return `${(0, format_number_1.createFormatNumber)(localizeConfigs)(locale, percentageValue, options)}\xa0%`;
    };
}
exports.createFormatPercentage = createFormatPercentage;
function createUseFormatPercentage(localizeConfigs) {
    return () => {
        const locale = (0, context_1._useLocalizeContext)();
        return (0, react_1.useMemo)(() => (0, curry_1._curry)(createFormatPercentage(localizeConfigs))(locale), [locale]);
    };
}
exports.createUseFormatPercentage = createUseFormatPercentage;
